import { render, staticRenderFns } from "./SdOverlay.vue?vue&type=template&id=792a7f6e&scoped=true"
import script from "./SdOverlay.vue?vue&type=script&lang=js"
export * from "./SdOverlay.vue?vue&type=script&lang=js"
import style0 from "./SdOverlay.vue?vue&type=style&index=0&id=792a7f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792a7f6e",
  null
  
)

export default component.exports